import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PagePropertiesReportRendererProps } from './pprTypes.ts';

export const PagePropertiesReportRenderer: LoadableType<PagePropertiesReportRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PagePropertiesReportRenderer" */ './PagePropertiesReportRenderer.tsx'
				)
			).PagePropertiesReportRenderer,
	});
